import { CryptlexProductVersion, FlattenedLicenseFeature } from './cryptlex-license';
import { AeroviewLicenseFeatures } from './license-features';

export function getLicenseName(features: AeroviewLicenseFeatures, productVersionsString: string): string {
  const productVersions: CryptlexProductVersion[] = JSON.parse(productVersionsString);

  // flatten features object & build array of only enabled features
  const enabledFeatures: FlattenedLicenseFeature[] = getLicenseEnabledFeatures(features);

  // compare with available features config to find license name
  const currentFeatureNames: string[] = enabledFeatures.map(feat => feat.name);
  const currentLicenseName: string | undefined = productVersions?.find(version => compareNormalizedArrays(currentFeatureNames, version.features))?.name;

  return currentLicenseName || 'EVIDENT LICENSE';
}

export function getLicenseEnabledFeatures(featuresObj: AeroviewLicenseFeatures): FlattenedLicenseFeature[] {
  const enabledFeatures: FlattenedLicenseFeature[] = [];
  Object.entries(featuresObj).forEach(([key, value]) => {
    if (value.enabled) {
      enabledFeatures.push({ name: key, expires: value.expires });
    }
  });

  return enabledFeatures;
}

/**
 * Generic array comparison, if when normalized they are the same.
 *
 * NOTE: Does not require array elements to be in the same order, and does not consider duplicates.
 * @param array1
 * @param array2
 */
export function compareNormalizedArrays(array1: any[], array2: any[]): boolean {
  if (!Array.isArray(array1) || !Array.isArray(array2)) {
    return false;
  }

  const set1: Set<any> = new Set(array1.map(el => JSON.stringify(el)));
  const set2: Set<any> = new Set(array2.map(el => JSON.stringify(el)));

  if (set1.size !== set2.size) {
    return false;
  }

  for (const el of set1) {
    if (!set2.has(el)) {
      return false;
    }
  }

  return true;
}
